import React from "react";

export default function DoubleProjectImage(post) {
  const {
    obj
  } = post;
  
    return (
      <div className={obj.fieldGroupName}>
<div className="textOverImage">
            <h3 className="small">{obj.optionalHeading}</h3>
            <hr />
            <div dangerouslySetInnerHTML={{__html: obj.optionalContent}}></div>
          </div>
        <div className="imageContainer">
        <span className="imgreveal"></span>
          <img src={obj.leftImage.sourceUrl + '.webp'} onError={(e)=>{ if (e.target.src !== obj.leftImage.sourceUrl){
                e.target.onerror = null;
                 e.target.src= obj.leftImage.sourceUrl;}
            }
       }/>
          
        </div>

        <div className="imageContainer">
        <span className="imgreveal"></span>
          <img src={obj.rightImage.sourceUrl + '.webp'} onError={(e)=>{ if (e.target.src !== obj.rightImage.sourceUrl){
                e.target.onerror = null;
                 e.target.src= obj.rightImage.sourceUrl;}
            }
       }/>
        </div>

      </div>
    );
  }  